// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recover-password-panel__container {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: auto;
    gap: var( --grid-gap );
    grid-template-areas: "left left left left right right right right right right right right";
    background-color: var( --white-color );
    height: 125vh;    
}

.recover-password-panel__left-col {
    grid-area: left;
    background-color: var( --primary-very-dark-color );
    height: 125vh;
}

.recover-password-panel__right-col {
    grid-column: 7 / 12;
    margin-top: calc( var( --space-x3 ) + var(--space-x2) );
}

.recover-password-panel__title  {
    
    margin-bottom: calc( var( --space-x3 ) - var( --space-quarter ));

    font-family: Barlow;
    font-style: normal;
    font-weight: 600;
    font-size: 30px;
    line-height: 36px;
    /* identical to box height */

    display: flex;
    align-items: center;
    justify-content: center;

    /* drak gray */

    color: #2A302A;
}

.recover-password-panel__text {
    margin-bottom: calc( var( --space-x2 ) - 2px );

    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 19px;
    line-height: 22px;
    display: flex;
    align-items: center;
    letter-spacing: 0.0025em;

    /* gray-base */

    color: #4D5451;
}

.recover-password-panel__form__submit {
    
    display: flex;
    justify-content: flex-end;
}

.recover-password-panel__form__submit .button {
   margin-top: var( --space-x3 );
}

.recover-password-panel__form__submit .button:first-of-type {
    background: transparent;
    box-shadow: none;    
    margin-top: var( --space-x3 );
}

.recover-password-panel__form__submit .recover-password-panel__form__login  span {
    color: #30B36B !important;
}

.recover-password-panel__form__submit .button span {
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 19px;
    line-height: 22px;
    display: flex;
    align-items: center;
    letter-spacing: 0.0025em;

    color: #FFFFFF;

    text-transform: capitalize;

}

.recover-password-panel__form__login {
    margin-right: var( --space-x2 );
}



















`, "",{"version":3,"sources":["webpack://./src/app/authentication/components/recover-password-panel/RecoverPasswordPanelComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sCAAsC;IACtC,wBAAwB;IACxB,sBAAsB;IACtB,0FAA0F;IAC1F,sCAAsC;IACtC,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,kDAAkD;IAClD,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,uDAAuD;AAC3D;;AAEA;;IAEI,gEAAgE;;IAEhE,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,4BAA4B;;IAE5B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB,cAAc;;IAEd,cAAc;AAClB;;AAEA;IACI,8CAA8C;;IAE9C,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,wBAAwB;;IAExB,cAAc;;IAEd,cAAc;AAClB;;AAEA;;IAEI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;GACG,6BAA6B;AAChC;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,wBAAwB;;IAExB,cAAc;;IAEd,0BAA0B;;AAE9B;;AAEA;IACI,+BAA+B;AACnC","sourcesContent":[".recover-password-panel__container {\n    display: grid;\n    grid-template-columns: repeat(12, 1fr);\n    grid-template-rows: auto;\n    gap: var( --grid-gap );\n    grid-template-areas: \"left left left left right right right right right right right right\";\n    background-color: var( --white-color );\n    height: 125vh;    \n}\n\n.recover-password-panel__left-col {\n    grid-area: left;\n    background-color: var( --primary-very-dark-color );\n    height: 125vh;\n}\n\n.recover-password-panel__right-col {\n    grid-column: 7 / 12;\n    margin-top: calc( var( --space-x3 ) + var(--space-x2) );\n}\n\n.recover-password-panel__title  {\n    \n    margin-bottom: calc( var( --space-x3 ) - var( --space-quarter ));\n\n    font-family: Barlow;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 30px;\n    line-height: 36px;\n    /* identical to box height */\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    /* drak gray */\n\n    color: #2A302A;\n}\n\n.recover-password-panel__text {\n    margin-bottom: calc( var( --space-x2 ) - 2px );\n\n    font-family: Roboto;\n    font-style: normal;\n    font-weight: 500;\n    font-size: 19px;\n    line-height: 22px;\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.0025em;\n\n    /* gray-base */\n\n    color: #4D5451;\n}\n\n.recover-password-panel__form__submit {\n    \n    display: flex;\n    justify-content: flex-end;\n}\n\n.recover-password-panel__form__submit .button {\n   margin-top: var( --space-x3 );\n}\n\n.recover-password-panel__form__submit .button:first-of-type {\n    background: transparent;\n    box-shadow: none;    \n    margin-top: var( --space-x3 );\n}\n\n.recover-password-panel__form__submit .recover-password-panel__form__login  span {\n    color: #30B36B !important;\n}\n\n.recover-password-panel__form__submit .button span {\n    font-family: Roboto;\n    font-style: normal;\n    font-weight: 500;\n    font-size: 19px;\n    line-height: 22px;\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.0025em;\n\n    color: #FFFFFF;\n\n    text-transform: capitalize;\n\n}\n\n.recover-password-panel__form__login {\n    margin-right: var( --space-x2 );\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
